import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
import { initializeUiTexts, t } from './utils/uiText';
import './assets/icon_font/iconfont.css';
Vue.use(Vant);

Vue.config.productionTip = false;
Vue.prototype.$tText = t;
Vue.prototype.$validCarPlateNo = (value = '') => {
  return /^[\u4eac\u6caa\u6d25\u6e1d\u5180\u664b\u8499\u8fbd\u5409\u9ed1\u82cf\u6d59\u7696\u95fd\u8d63\u9c81\u8c6b\u9102\u6e58\u7ca4\u6842\u743c\u5ddd\u8d35\u4e91\u85cf\u9655\u7518\u9752\u5b81\u65b0][A-Z](([\dA-Z]{5,6}$)|([\dA-Z]{4,5}[\u6e2f\u6fb3\u5b66\u8b66]$))/.test(
    String(value || '').toUpperCase()
  );
};

function isWeChatRuntime() {
  if (typeof window === 'undefined') {
    return false;
  }

  const ua = window.navigator.userAgent || '';
  const hasWeChatUa = /MicroMessenger/i.test(ua);
  const isMiniProgram =
    window.__wxjs_environment === 'miniprogram' ||
    /miniProgram/i.test(ua) ||
    !!(window.wx && window.wx.miniProgram);

  return hasWeChatUa || isMiniProgram;
}

function loadWeChatSdk() {
  if (!isWeChatRuntime() || typeof document === 'undefined') {
    return Promise.resolve(false);
  }

  if (window.wx) {
    return Promise.resolve(true);
  }

  const existingScript = document.querySelector('script[data-wechat-sdk="true"]');
  if (existingScript) {
    return Promise.resolve(true);
  }

  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
    script.async = true;
    script.setAttribute('data-wechat-sdk', 'true');
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
}

async function bootstrap() {
  await loadWeChatSdk();
  await initializeUiTexts();

  const app = new Vue({
    router,
    render: h => h(App),
  }).$mount('#app');

  window.vueApp = app;
}

bootstrap();
